import React from "react";

export default function EyeClosedIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12L9.51868 9.83334M1.33334 5.33334C1.83225 6.70053 2.73943 7.88127 3.93194 8.71554C5.12446 9.54981 6.54464 9.99727 8.00001 9.99727C9.45538 9.99727 10.8756 9.54981 12.0681 8.71554C13.2606 7.88127 14.1678 6.70053 14.6667 5.33334M13.3333 10L12.1827 8.63334M2.66668 10L3.81734 8.63334M6.00001 12L6.48134 9.83334"
        stroke="#71717A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
